const privateStore = {}

export function setBackboneAppState (backboneAppState) {
  privateStore.state = backboneAppState
}

export function getBackboneAppState () {
  return privateStore.state
}
